/**
 * 비밀번호 유효성 검사 함수
 * - 영문, 숫자, 특수문자 혼합 8자 이상인지 확인
 * @param {string} password - 검사할 비밀번호
 * @returns {boolean} - 유효성 검사 통과 여부
 */
export default function validatePassword(password) {
  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  const hasMinLength = password.length >= 8;

  return hasLetter && hasNumber && hasSpecial && hasMinLength;
}
